module.exports = __webpack_public_path__ + "static/media/Solution Marketplace - GBR network - 27-05-2025 N.3feb6436.gif";